import React from "react" ;
import {Route, Switch} from "react-router-dom";

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";
import ApprovalsAppSubmenu from "./ApprovalsAppSubmenu";
import {PATH_APPROVALS_ROOT, getApprovalsRouterLink, PATH_HOME_ROOT} from "root/Wieldy/routePaths";
import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import AppSidebarHeader from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarHeader";

const ApprovalsAppSidebar= (props) =>
{
    return (
        <div className="dt-module__sidebar">

            <AppSidebarHeader iconName={props.iconName} title={props.title} />

            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    <AppSidebarGroup title='View' default='resources'>
                        <AppSidebarMenuItem link={getApprovalsRouterLink()} title='To Approve' iconName='icon-important' name='approvals' />
                    </AppSidebarGroup>

                    <Switch>
                        <Route path={PATH_APPROVALS_ROOT} render={(thisprops) => <ApprovalsAppSubmenu {...thisprops}/>}/>
                        <Route exact path={PATH_APPROVALS_ROOT} render={(thisprops) => <ApprovalsAppSubmenu {...thisprops}/>}/>
                        <Route exact path={PATH_HOME_ROOT} render={(thisprops) => <ApprovalsAppSubmenu {...thisprops}/>}/>
                    </Switch>

                </ul>

                <ScrollRails />

            </div>

        </div>
    ) ;
}

export default ApprovalsAppSidebar;
